import { Tab } from '@shared/components/page-tabs';
import { generatePath } from 'react-router-dom';
import { pcfRoutes } from '../pcf-routes';
import { useIngredientDetailContext } from './ingredient-detail-context';

export function useIngredientDetailTabs(): Tab[] {
  const { item } = useIngredientDetailContext();
  return [
    {
      title: 'Item',
      href: generatePath(pcfRoutes.PRODUCT_COMPONENTS_INGREDIENTS_DETAIL, {
        ingredient_uuid: item?.uuid || ':ingredient_uuid',
      }),
    },
  ];
}
